import { EnumStatusConekta } from "../../../../settings/enumConfig";
import { Fragment } from "react";
import { Grid } from "@material-ui/core";
import MeditocInfoField from "../../../utils/MeditocInfoField";
import MeditocInfoResumen from "../../../utils/MeditocInfoResumen";
import MeditocModal from "../../../utils/MeditocModal";
import MeditocSubtitulo from "../../../utils/MeditocSubtitulo";
import MeditocTableSimple from "../../../utils/MeditocTableSimple";
import { useLogin } from "../../../../context/LoginContext";
import { useReporteVenta } from "../../../../context/ReporteVentaContext";

export default function DetalleOrden() {
    const { usuarioPermisos } = useLogin();
    const { ordenSeleccionada, modalOpenDetalleOrden, handleOpenDetalleOrden, handleClickReenviarCorreo } =
        useReporteVenta();

    const permisos = usuarioPermisos["5"].Submodulos["1"];

    return (
        <MeditocModal
            size="normal"
            open={modalOpenDetalleOrden}
            setopen={handleOpenDetalleOrden}
            okfunc={handleClickReenviarCorreo}
            okmessage="Reenviar correo de órden"
            cancelMessage="Cerrar detalle de órden"
            title={"Detalle de orden " + ordenSeleccionada.sOrderId}
            hideOk={
                ordenSeleccionada.sPaymentStatus === EnumStatusConekta.Declined || permisos.Botones["3"] === undefined
            }
        >
            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <MeditocInfoResumen
                        label="Subtotal"
                        value={ordenSeleccionada.nAmount.toLocaleString("en", {
                            minimumFractionDigits: 2,
                        })}
                    />
                    <MeditocInfoResumen
                        label="Descuento"
                        value={
                            "- " +
                            ordenSeleccionada.nAmountDiscount.toLocaleString("en", {
                                minimumFractionDigits: 2,
                            })
                        }
                    />
                    <MeditocInfoResumen
                        label="IVA"
                        value={
                            "+ " +
                            ordenSeleccionada.nAmountTax.toLocaleString("en", {
                                minimumFractionDigits: 2,
                            })
                        }
                    />
                    <MeditocInfoResumen
                        label="Total pagado"
                        value={ordenSeleccionada.nAmountPaid.toLocaleString("en", {
                            minimumFractionDigits: 2,
                        })}
                    />
                </Grid>
                <Grid item xs={12}>
                    <MeditocSubtitulo title="DATOS DE CLIENTE" />
                </Grid>
                <Grid item xs={12}>
                    <MeditocInfoField label="Nombre:" value={ordenSeleccionada.customer_info.name} />
                </Grid>
                <Grid item sm={6} xs={12}>
                    <MeditocInfoField label="Correo:" value={ordenSeleccionada.customer_info.email} />
                </Grid>
                <Grid item sm={6} xs={12}>
                    <MeditocInfoField label="Teléfono:" value={ordenSeleccionada.customer_info.phone} />
                </Grid>
                <Grid item xs={12}>
                    <MeditocSubtitulo title="DATOS DE PAGO" />
                </Grid>
                <Grid item sm={6} xs={12}>
                    <MeditocInfoField label="Tipo de pago:" value={ordenSeleccionada.charges.sType} />
                </Grid>
                <Grid item sm={6} xs={12}>
                    <MeditocInfoField
                        label="No. de autorización del banco:"
                        value={ordenSeleccionada.charges.sAuthCode}
                    />
                </Grid>
                <Grid item sm={6} xs={12}>
                    <MeditocInfoField label="ID de cargo:" value={ordenSeleccionada.charges.sChargeId} />
                </Grid>
                <Grid item sm={6} xs={12}>
                    <MeditocInfoField label="ID de control de compra:" value={ordenSeleccionada.uId} />
                </Grid>
                <Grid item xs={12}>
                    <MeditocSubtitulo
                        title={
                            ordenSeleccionada.sPaymentStatus === EnumStatusConekta.Declined
                                ? "PRODUCTOS RECHAZADOS"
                                : "PRODUCTOS ADQUIRIDOS"
                        }
                    />
                </Grid>
                <Grid item xs={12}>
                    {ordenSeleccionada.lstProductos.map((producto, index) => (
                        <Fragment key={producto.sItemId}>
                            <div className={"reporte-producto-header " + (index === 0 ? "mar-top-20" : "mar-top-50")}>
                                {ordenSeleccionada.plan != null
                                    ? `${1}.- ${ordenSeleccionada.plan.sNombre}${" - " + ordenSeleccionada.plan.sTipo}`
                                    : `${index + 1}.- ${producto.sNombre}${
                                          producto.sTipoProducto === null ? "" : " - " + producto.sTipoProducto
                                      }`}
                            </div>
                            {ordenSeleccionada.plan == null ? (
                                <div className="center">
                                    <span className="rob-nor normal color-4 size-15">ID de control artículo:</span>{" "}
                                    <span className="rob-nor bold color-3 size-15">{producto.sItemId}</span>
                                    <br />
                                    <span className="rob-nor normal color-4 size-15">Precio unitario:</span>{" "}
                                    <span className="rob-nor bold color-3 size-15">
                                        $
                                        {producto.nUnitPrice.toLocaleString("en", {
                                            minimumFractionDigits: 2,
                                        })}
                                    </span>
                                    <br />
                                    <span className="rob-nor normal color-4 size-15">Cantidad:</span>{" "}
                                    <span className="rob-nor bold color-3 size-15">{producto.iQuantity}</span>
                                </div>
                            ) : (
                                <div className="center">
                                    <span className="rob-nor normal color-4 size-15">ID del Plan:</span>{" "}
                                    <span className="rob-nor bold color-3 size-15">
                                        {ordenSeleccionada.plan.sIdPlan}
                                    </span>
                                    <br />
                                    <span className="rob-nor normal color-4 size-15">Precio unitario:</span>{" "}
                                    <span className="rob-nor bold color-3 size-15">
                                        $
                                        {ordenSeleccionada.plan.nUnitPrice.toLocaleString("en", {
                                            minimumFractionDigits: 2,
                                        })}
                                    </span>
                                    <br />
                                    <span className="rob-nor normal color-4 size-15">Fecha Vencimiento:</span>{" "}
                                    <span className="rob-nor bold color-3 size-15">
                                        {ordenSeleccionada.plan.sFechaVencimiento}
                                    </span>
                                </div>
                            )}
                            {ordenSeleccionada.plan == null
                                ? producto.lstFolios.length > 0 && (
                                      <div>
                                          <MeditocTableSimple
                                              columns={[
                                                  { title: "Folio", field: "sFolio" },
                                                  { title: "Confirmado", field: "bConfirmado" },
                                                  { title: "Vencimiento", field: "sFechaVencimiento" },
                                              ]}
                                              data={producto.lstFolios}
                                          />
                                      </div>
                                  )
                                : null}
                        </Fragment>
                    ))}
                </Grid>
            </Grid>
        </MeditocModal>
    );
}
